export default __webpack_public_path__ + "static/media/zoom-logo.607e89cf.png";